var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.creditCard.status === "Unverified"
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary btn-sm m-r-10",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.verifyCard }
          },
          [_vm._v("\n    " + _vm._s(_vm.$t("VERIFY")) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.creditCard.default
      ? _c(
          "button",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right",
                value: _vm.$t("ACCOUNT_BILLING_CC_REMOVE_TT"),
                expression: "$t('ACCOUNT_BILLING_CC_REMOVE_TT')",
                modifiers: { right: true }
              }
            ],
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.deleteCard }
          },
          [_c("i", { staticClass: "typcn typcn-trash" })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }